import type {
  EquipmentAccessorialType,
  EquipmentTypeDefinition,
} from './constants.ts'

type PartialEquipmentTypeDefinition = Pick<
  EquipmentTypeDefinition,
  'key' | 'name'
> &
  Partial<EquipmentTypeDefinition>
type EquipmentCategoryDefaults = Omit<EquipmentTypeDefinition, 'key' | 'name'>

export const createEquipmentCategory = (
  defaults: EquipmentCategoryDefaults,
  partials: PartialEquipmentTypeDefinition[],
): EquipmentTypeDefinition[] => {
  return partials.map<EquipmentTypeDefinition>(partial => ({
    ...defaults,
    ...partial,
  }))
}

export const defaultAccessorials: EquipmentAccessorialType[] = ['team-driver']
